import React from "react";
import { HomeInfo } from "../../components";

const HomePage = ({}) => {
  return <HomeInfo />;
};

HomePage.propTypes = {};
HomePage.defaultProps = {};

export default HomePage;
